<p>🚧 Na dokončení této funkce pilně pracujeme 🐝</p>
<p>
  K diagnostickým výsledkům a dalším materiálům
  <br />
  můžete přistupovat zde přes web
  <a href="https://pedagog.isophi.education/" target="_blank">Moje iSophi</a>.
</p>
